import { gql } from "@apollo/client";

export const QUERY_HEALTHPLAN_REPORT = gql`
  query (
      $schoolIds: [ID], 
      $selectedFields: [String],
    ) {
    healthPlanReport(
      schoolIds: $schoolIds, 
      selectedFields: $selectedFields
    ) {
      success
      message
      reportDataJson
    }
  }
`;
